// @ts-nocheck - verbatim port from my-location-next/utils (plain JS, not authored to TS strict). Type it if/when reworked.
export const decimalToDMS = (decimal, isLatitude) => {
  // Work in tenths of a second, the precision shown, so rounding can never
  // print 60 seconds or 60 minutes: they roll over to the next unit.
  const tenths = Math.round(Math.abs(decimal) * 36000);
  const degrees = Math.floor(tenths / 36000);
  const minutes = Math.floor((tenths % 36000) / 600);
  // Two-digit seconds with one decimal ("04.0"), as on Android and iOS.
  const seconds = ((tenths % 600) / 10).toFixed(1).padStart(4, '0');

  const direction = isLatitude 
    ? (decimal >= 0 ? "N" : "S")
    : (decimal >= 0 ? "E" : "W");

  // Pad minutes with leading zero if less than 10
  const paddedMinutes = minutes.toString().padStart(2, '0');

  return `${degrees}°${paddedMinutes}'${seconds}"${direction}`;
};

export const decimalToDirectional = (decimal, isLatitude) => {
  const absolute = Math.abs(decimal);
  const direction = isLatitude 
    ? (decimal >= 0 ? "N" : "S")
    : (decimal >= 0 ? "E" : "W");

  // Format to 4 decimal places
  return `${absolute.toFixed(4)} ${direction}`;
};

// Helper function to format both coordinates together
export const formatCoordinates = (lat, lng, format = 'DMS') => {
  if (format === 'DMS') {
    return `${decimalToDMS(lat, true)} ${decimalToDMS(lng, false)}`;
  } else if (format === 'directional') {
    return `${decimalToDirectional(lat, true)}, ${decimalToDirectional(lng, false)}`;
  }
};
